import { render, staticRenderFns } from "./LunchModal.vue?vue&type=template&id=10d9cf9a&scoped=true&"
import script from "./LunchModal.vue?vue&type=script&lang=js&"
export * from "./LunchModal.vue?vue&type=script&lang=js&"
import style0 from "./LunchModal.vue?vue&type=style&index=0&id=10d9cf9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d9cf9a",
  null
  
)

export default component.exports